var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"d-block p-11  menuHover my-1 px-4 py-1 font-medium text-gray-800",attrs:{"href":"#"},on:{"click":function($event){return _vm.$emit('onClick', _vm.value)}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }